// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "2c7c8ff4e53e5f83b08a" + ".chunk.js";
};